import AJAX from 'utils/ajax'
import Quimbee from 'quimbee'

export default class AudioPlayer {
  constructor() {
    Quimbee.data.audioContext ||= window.AudioContext ? new AudioContext() : null
    this.audioContext = Quimbee.data.audioContext
  }

  async setAudioFile(audioFileUrl) {
    const response = await AJAX.get(audioFileUrl)
    const arrayBuffer = await response.arrayBuffer()
    const audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer)
    this.verificationPromptAudioBuffer = audioBuffer
  }

  enabled() {
    return !!this.audioContext
  }

  ready() {
    return !!this.verificationPromptAudioBuffer
  }

  async play() {
    const soundSource = this.audioContext.createBufferSource()
    soundSource.buffer = this.verificationPromptAudioBuffer
    soundSource.connect(this.audioContext.destination)
    soundSource.start(0)
  }

  // This function is used to unlock the audio context from a user triggered action.
  // Safari does not allow the sounds to be played programmatically unless it's first triggered by the user.
  unlock() {
    if (this.enabled()) {
      const gainNode = this.audioContext.createGain()
      const oscillator = this.audioContext.createOscillator()

      oscillator.type = 'square'
      oscillator.frequency.value = 500

      oscillator.connect(gainNode)

      gainNode.connect(this.audioContext.destination)

      gainNode.gain.setValueAtTime(0, this.audioContext.currentTime)

      oscillator.start(0)
      oscillator.stop(0)
    }
  }
}
